<script setup lang="ts">
import { useI18n } from '@/i18n'

const { t } = useI18n()
</script>

<template>
  <div class="legal-view">
    <div class="legal-container">
      <h1>{{ t('terms.title') }}</h1>
      <p class="last-update">{{ t('terms.last_update') }}: 15/01/2026</p>
      
      <section>
        <h2>1. {{ t('terms.acceptance.title') }}</h2>
        <p>{{ t('terms.acceptance.content') }}</p>
      </section>
      
      <section>
        <h2>2. {{ t('terms.service.title') }}</h2>
        <p>{{ t('terms.service.content') }}</p>
        <ul>
          <li>{{ t('terms.service.item1') }}</li>
          <li>{{ t('terms.service.item2') }}</li>
          <li>{{ t('terms.service.item3') }}</li>
          <li>{{ t('terms.service.item4') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>3. {{ t('terms.credits.title') }}</h2>
        <p>{{ t('terms.credits.content') }}</p>
        <ul>
          <li>{{ t('terms.credits.item1') }}</li>
          <li>{{ t('terms.credits.item2') }}</li>
          <li>{{ t('terms.credits.item3') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>4. {{ t('terms.content.title') }}</h2>
        <p>{{ t('terms.content.content') }}</p>
        <ul>
          <li>{{ t('terms.content.item1') }}</li>
          <li>{{ t('terms.content.item2') }}</li>
          <li>{{ t('terms.content.item3') }}</li>
        </ul>
      </section>
      
      <section>
        <h2>5. {{ t('terms.intellectual.title') }}</h2>
        <p>{{ t('terms.intellectual.content') }}</p>
      </section>
      
      <section>
        <h2>6. {{ t('terms.liability.title') }}</h2>
        <p>{{ t('terms.liability.content') }}</p>
      </section>
      
      <section>
        <h2>7. {{ t('terms.termination.title') }}</h2>
        <p>{{ t('terms.termination.content') }}</p>
      </section>
      
      <section>
        <h2>8. {{ t('terms.modifications.title') }}</h2>
        <p>{{ t('terms.modifications.content') }}</p>
      </section>
      
      <section>
        <h2>9. {{ t('terms.contact.title') }}</h2>
        <p>{{ t('terms.contact.content') }}</p>
        <p class="contact-email">📧 contact@m2v.io</p>
      </section>
    </div>
  </div>
</template>

<style scoped>
.legal-view {
  min-height: calc(100vh - 64px);
  padding: var(--m2v-space-12) var(--m2v-space-6);
}

.legal-container {
  max-width: 800px;
  margin: 0 auto;
}

h1 {
  font-family: var(--m2v-font-display);
  font-size: 2.5rem;
  margin-bottom: var(--m2v-space-2);
}

.last-update {
  color: var(--m2v-text-muted);
  font-size: 0.875rem;
  margin-bottom: var(--m2v-space-10);
}

section {
  margin-bottom: var(--m2v-space-8);
}

h2 {
  font-size: 1.25rem;
  margin-bottom: var(--m2v-space-4);
  color: var(--m2v-text-primary);
}

p {
  color: var(--m2v-text-secondary);
  line-height: 1.7;
  margin-bottom: var(--m2v-space-4);
}

ul {
  list-style: disc;
  padding-left: var(--m2v-space-6);
  color: var(--m2v-text-secondary);
  margin-bottom: var(--m2v-space-4);
}

li {
  line-height: 1.7;
  margin-bottom: var(--m2v-space-2);
}

.contact-email {
  color: var(--m2v-primary-light);
  font-weight: 500;
}
</style>
